import { memo } from 'react';
import { AlertTriangle } from 'lucide-react';
import { cn } from '../../utils/cn';

interface KanbanWIPIndicatorProps {
  count: number;
  limit: number | null;
  className?: string;
}

export const KanbanWIPIndicator = memo(({ count, limit, className }: KanbanWIPIndicatorProps) => {
  if (limit === null) {
    return (
      <span className={cn('badge badge-neutral', className)} title={`${count} card${count === 1 ? '' : 's'}`}>
        {count}
      </span>
    );
  }
  const isOver = count > limit;
  const isAt = count === limit;
  return (
    <span
      className={cn(
        'badge',
        isOver ? 'badge-danger' : isAt ? 'badge-warning' : 'badge-neutral',
        className,
      )}
      title={isOver ? `Over WIP limit (${count}/${limit})` : `WIP ${count}/${limit}`}
    >
      {count}/{limit}
      {isOver && <AlertTriangle className="w-3 h-3" aria-label="Over WIP limit" />}
    </span>
  );
});
KanbanWIPIndicator.displayName = 'KanbanWIPIndicator';
